'use client'

import Link from 'next/link'
import { useEffect } from 'react'
import ThemeToggle from '../ui/ThemeToggle'

import styles from './MobileMenu.module.scss'
import { useParams } from 'next/navigation'

type MobileMenuProps = {
  isVisiable: boolean
  navigation: any
  dictionary: Awaited<ReturnType<any>>
  otherLanguages: any,
  onClick: () => void
}

const MobileMenu = ({ isVisiable, navigation, dictionary, otherLanguages, onClick }: MobileMenuProps) => {
  const { lang } = useParams<{ lang: string }>();

  useEffect(() => {
    document.body.style.overflowY = isVisiable ? 'hidden' : '';
  }, [isVisiable])

  return (
    <>
      <dialog className={styles.mobileMenu} data-state={isVisiable ? 'visiable' : 'hide'}>
        <nav className={styles.nav}>
          <section>
            <ul>
              {navigation.menu?.map((item: any, index: number) => (
                <li key={'mobileMenu' + index} className={styles.item}>
                  <Link href={`${lang === 'fa' ? '' : `/${lang}`}/${item.link}`} prefetch={false} className={styles.item__link} onClick={onClick}>{item.title}</Link>
                </li>
              ))}
            </ul>
          </section>
          <section className={styles.settings}>
            <ul className={styles.settingsMenu}>
              <li key={'theme'} className={styles.item}>
                <span>{dictionary.theme}</span>
                <ThemeToggle type='switch' />
              </li>
              <li key={'language'} className={styles.item}>
                <span>{dictionary.language}</span>
                <ul className={styles.languagesMenu}>
                  {otherLanguages.map(({name, locale}: {name: string, locale: string}) => {
                    if (name) {
                      return <li key={locale} className={styles.languageLabel}>
                        <Link className={styles.languageLabel__link} href={`/${locale || ''}`} prefetch={false} shallow={lang === 'fa'}>{name}</Link>
                      </li>
                    }
                  })}
                </ul>
              </li>
            </ul>
          </section>
        </nav>
      </dialog>
    </>
  )
}


export default MobileMenu